import { useTranslation } from 'react-i18next';

import { PracticalInfoTopic } from '__generated__/graphql';

import { ChevronDown, ChevronUp } from 'react-feather';
import { NavItem, Section, useDropdownSectionState } from '../../Common/Layout';
import { PracticalInfoIcon, getPracticalInfoFactTitle } from '../../../common/practicalInfo';
import { RegistrationSummary } from '../helpers';
import UI from '../../../common/UI';

export interface PracticalInfoSectionProps {
  summary: RegistrationSummary;
  topics: PracticalInfoTopic[];
}

const PracticalInfoSection = ({ summary, topics }: PracticalInfoSectionProps) => {
  const { t } = useTranslation();
  const { isOpen, toggleSection } = useDropdownSectionState();

  const facts = summary.event.practical_info_facts;

  return (
    <Section title={t('practical_info')}>
      {facts.map((fact) => (
        <NavItem
          onClick={() => toggleSection(fact.id)}
          icon={isOpen(fact.id) ? <ChevronUp /> : <ChevronDown />}
          title={getPracticalInfoFactTitle(fact.title, topics, t)}
          key={fact.id}
        >
          <UI.GridContainer sc={{ columns: '14px 1fr', gutter: 0.5 }}>
            <UI.Div>
              <UI.Icon sc={{ color: 'gray.500', mb: 0 }}>
                <PracticalInfoIcon topic={fact.title} />
              </UI.Icon>
            </UI.Div>
            <UI.Div>
              <UI.H4 sc={{ py: 0.25 }}>
                {getPracticalInfoFactTitle(fact.title, topics, t)}
              </UI.H4>
              <UI.AnimateHeight isVisible={isOpen(fact.id)}>
                <UI.Div
                  sc={{
                    padding: 1, mt: 1, mx: -1, mb: -1, relative: true, zIndex: 301,
                  }}
                >
                  <UI.HTML html={fact.description} />
                </UI.Div>
              </UI.AnimateHeight>
            </UI.Div>
          </UI.GridContainer>
        </NavItem>
      ))}
    </Section>
  );
};

export default PracticalInfoSection;
